import { useDraggable } from '@dnd-kit/core'
import { Button } from '@mui/material'
import styled from 'styled-components'
import map from 'lodash/map'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { surfaces } from '../../../theme'

/**
 * DraggableDay component with drag-and-drop functionality.
 * */

export const DraggableDay = ({ formattedDate, currentDateFlightGroups, isSelected, dayInCurrentMonth, date, selectDate }) => {
  const { isDragging, attributes, listeners, setNodeRef, transform } = useDraggable({
    id: formattedDate,
    disabled: isSelected,
    data: {
      date: formattedDate,
      currentDateFlightGroups
    }
  })

  return (
    <>
      <Button
        className={`
          ${isSelected && 'Mui-selected'} 
          ${currentDateFlightGroups && 'Mui-withSources'}
          ${dayInCurrentMonth.today && 'Mui-today'} 
          `}
        type="button"
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        key={formattedDate}
        onClick={selectDate}
      >
        {date.date()}
        <DotsWrapper>
          {map(currentDateFlightGroups, flightGroup => (
            <Dot key={flightGroup.source} color={flightGroup.color} />
          ))}
        </DotsWrapper>
        <span className="MuiTouchRipple-root" />
      </Button>
      {isDragging ? <DraggableDayStyle transform={transform}>{date.date()}</DraggableDayStyle> : null}
    </>
  )
}

const DotsWrapper = styled.div`
  position: absolute;
  display: flex;
  bottom: 3px;
`
const Dot = styled.div`
  width: 5px;
  height: 5px;
  background: ${props => props.color};
  border-radius: 50%;
  margin: 0 1px;
`
// The carried day is raised over the calendar: navy with a mint contour and a floating shadow.
const DraggableDayStyle = styled.div`
  transform: ${({ transform }) => (transform ? `translate(${transform.x}px, ${transform.y - 36}px)` : '')};
  position: fixed;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${themeColors.deepblueColor3};
  box-shadow: inset 0 0 0 1px ${themeColors.mintColor}, ${surfaces.floatingPanelShadow};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  font-size: 12.5px;
`
